import { useState } from 'react';
import axios from 'axios';
import bank from '../bankList';

export function useAccountHolderVerify({ formData, setFormData, setMessage }) {
    const [verifying, setVerifying] = useState(false);
    const [verifiedSnapshot, setVerifiedSnapshot] = useState(null);

    const currentAccount = (formData.계좌번호 || '').trim();
    const isVerified = !!verifiedSnapshot
        && verifiedSnapshot.bank === formData.정산은행
        && verifiedSnapshot.account === currentAccount
        && verifiedSnapshot.holder === formData.예금주;

    const verify = async () => {
        if (verifying) return;
        const bankName = formData.정산은행;
        const account = (formData.계좌번호 || '').replace(/-/g, '').trim();
        if (!bankName) {
            setMessage({ msg: '정산은행을 먼저 선택해 주세요.' });
            return;
        }
        const bankCode = bank.find(b => b.name === bankName)?.code;
        if (!bankCode) {
            setMessage({ msg: '선택된 은행의 코드를 찾을 수 없습니다. 은행을 다시 선택해 주세요.' });
            return;
        }
        if (!/^\d{10,20}$/.test(account)) {
            setMessage({ msg: '계좌번호는 숫자 10~20자리로 입력해 주세요.' });
            return;
        }
        setVerifying(true);
        try {
            const res = await axios.post(
                process.env.REACT_APP_API + "/api/transfer/account-holder",
                { bankCode, account },
                { withCredentials: true }
            );
            const depositor = res.data?.data?.depositor;
            if (res.data?.code === 1000 && depositor) {
                setFormData(prev => ({ ...prev, 예금주: depositor, 계좌번호: account }));
                setVerifiedSnapshot({ bank: bankName, account, holder: depositor });
            } else {
                setMessage({ msg: res.data?.msg || '예금주 조회에 실패했습니다.' });
            }
        } catch (e) {
            console.error(e);
            setMessage({ msg: '예금주 조회 중 오류가 발생했습니다.' });
        } finally {
            setVerifying(false);
        }
    };

    return { verifying, isVerified, verify };
}

export const verifyBtnStyle = (verifying) => ({
    width: "68px",
    height: "26px",
    fontSize: "11px",
    border: "1px solid #3b82f6",
    backgroundColor: verifying ? "#e5e7eb" : "#3b82f6",
    color: verifying ? "#6b7280" : "#fff",
    borderRadius: "4px",
    cursor: verifying ? "default" : "pointer",
    marginLeft: "4px",
    flexShrink: 0,
});

export const verifiedBadgeStyle = {
    display: "inline-flex",
    alignItems: "center",
    height: "20px",
    padding: "0 6px",
    fontSize: "10px",
    color: "#047857",
    backgroundColor: "#d1fae5",
    border: "1px solid #6ee7b7",
    borderRadius: "4px",
    marginLeft: "4px",
    flexShrink: 0,
    whiteSpace: "nowrap",
};
